import { Reader } from "fp-ts/Reader";
import { Box, ContentRow } from "@dbn/omnichannel-design-system-g4p";
import * as api from "../api";
import {
  RefinancingAccountSelection,
  SelectedLoansInformation,
} from "./RefinancingAccountSelection";
import { LiabilityFormModel } from "../domain";
import { boolean, option } from "fp-ts";
import { pipe } from "fp-ts/function";
import { PreapprovedLimitState } from "../CustomerOffer/UpdateCustomerOfferContext";
import { Currency } from "../../globalDomain";

type Props = {
  onLoanSelection: Reader<SelectedLoansInformation, void>;
  liabilities: api.RefinancingLoanListOutput;
  clientExists: boolean;
  preapprovedLimitState: PreapprovedLimitState;
  refinancingLimitExceeded: boolean;
  maxLoanAmount: number;
  internal: LiabilityFormModel[];
  external: LiabilityFormModel[];
  preapprovedLimit: number;
  preapprovedLimitCurrency: Currency;
  isTopUpActive: boolean;
  eligibleForPreapproved: number;
};

export function RefinancingCreditsCheck(props: Props) {
  return (
    <ContentRow type="full">
      <Box grow shrink column>
        <RefinancingAccountSelection
          topUp={pipe(
            props.clientExists && props.preapprovedLimit > 0,
            boolean.fold(
              () => option.none,
              () =>
                option.some({
                  limit: {
                    amount: props.preapprovedLimit,
                    currency: props.preapprovedLimitCurrency,
                  },
                })
            )
          )}
          isTopUpActive={props.isTopUpActive}
          internal={props.internal}
          external={props.external}
          maximumPreapprovedLimit={props.preapprovedLimit}
          liabilities={props.liabilities}
          onLoanSelection={props.onLoanSelection}
          refinancingLimitExceeded={props.refinancingLimitExceeded}
          maxLoanAmount={props.maxLoanAmount}
          eligibleForPreapproved={props.eligibleForPreapproved}
        />
      </Box>
    </ContentRow>
  );
}
